import type { TArgument } from '@/types/common';

/**
 * Get the arguments dictionary from the arguments
 * @param args - The arguments
 * @returns The arguments dictionary
 */
export const getArgumentsDictionary = (args: TArgument[]) =>
	args.reduce(
		(accumulator, arg) => {
			accumulator[arg.name] = arg.value;
			return accumulator;
		},
		{} as Record<string, string>
	);

/**
 * Check if the current window is in an iframe
 * @returns boolean
 */
export const isInIframe = (): boolean => {
	try {
		return window.self !== window.top;
	} catch {
		return true;
	}
};
